import React from 'react'
import { GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid-pro'
import { type GridCsvExportOptions } from '@mui/x-data-grid/models/gridExport'
import { type GridExportDisplayOptions } from '@mui/x-data-grid/components/toolbar/GridToolbarExport'

export interface FilterExportGridToolbarProps {
  csvOptions?: GridCsvExportOptions & GridExportDisplayOptions
}

const FilterExportGridToolbar: React.FC<FilterExportGridToolbarProps> = ({ csvOptions }) => {
  return (
    <GridToolbarContainer sx={{ display: 'flex', flexDirection: 'row', paddingX: 1 }}>
      <GridToolbarFilterButton/>
      <GridToolbarExport csvOptions={csvOptions}/>
    </GridToolbarContainer>
  )
}

export default FilterExportGridToolbar
